import update from '../../../helpers/Immutability';

export const notValidateUpdateValue = (formName, value, field, changeFormField) => {
    const newField = update(field, {
        value: { $set: value },
    });
    changeFormField(formName, newField);
    return Promise.resolve(newField);
};
